import { HeroBanner } from '@ahmdigital/ui';
import portableTextToPlain from '@ahmdigital/logic/lib/content/utils/portable-text-to-plain';
import React from 'react';

import { CONTENT_SECTIONS } from './content/sections';
import Award from '../insurance/components/award';
import CommonQuestions from '../insurance/components/common-questions';
import ContactDetails from './components/contact-details';
import ContentTilesSection from '../../components/content-tiles-section';
import Head from '../../../utils/head';
import Inclusions from '../insurance/components/inclusions';
import OfferBanner from '../../components/offers/banner';
import PageSections from './components/page-sections';
import ProductsSection from '../../components/sections/products-section';
import RequestACallDrawer from '../../components/request-a-call/drawer';
import ValuePropositions from '../insurance/components/value-propositions';

const getComponents = () => ({
  [CONTENT_SECTIONS.AWARD]: Award,
  [CONTENT_SECTIONS.HEADER]: HeroBanner,
  [CONTENT_SECTIONS.OFFER]: OfferBanner,
  [CONTENT_SECTIONS.VALUE_PROPOSITIONS]: ValuePropositions,
  [CONTENT_SECTIONS.SELLING_POINTS_GROUP]: Inclusions,
  [CONTENT_SECTIONS.TILES]: ContentTilesSection,
  [CONTENT_SECTIONS.CONTACT_DETAILS]: ContactDetails,
  [CONTENT_SECTIONS.COMMON_QUESTIONS]: CommonQuestions,
  [CONTENT_SECTIONS.PRODUCT_LISTING]: ProductsSection,
});

export type ConsiderationLandingPageProps = {
  content: any;
};

const ConsiderationLandingPage = ({ content }: ConsiderationLandingPageProps) => {
  const metadataObject = content?.explainedTerm?.metadataObject;
  const title = metadataObject?.name || '';
  const description = metadataObject?.descriptionRaw || '';
  const titleTemplate = '%s - ahm insurance';
  return (
    <>
      <Head titleTemplate={titleTemplate}>
        <title>{title}</title>
        <meta name="description" content={portableTextToPlain(description)} />
      </Head>
      <PageSections components={getComponents()} content={content} />
      <RequestACallDrawer />
    </>
  );
};

export default ConsiderationLandingPage;
